import store from "../store";

// `role` can be a single role or an array of allowed roles
export function hasRole(role) {
  const userRole = store.getters.userInfo.role;
  return Array.isArray(role) ? role.includes(userRole) : userRole === role;
}

export function hasPermission(permission) {
  return store.getters.userInfo.permission.includes(permission);
}

export function hasMultiplePermission(requiredPermissions) {
  const userPermissions = store.getters.userInfo.permission;
  if (Array.isArray(requiredPermissions)) {
    return requiredPermissions.some((permission) =>
      userPermissions.includes(permission)
    );
  }
  return userPermissions.includes(requiredPermissions);
}
